import React from 'react';
import { FaRegMoneyBill1 } from 'react-icons/fa6';
import { useSelector } from 'react-redux';

import { Box, ButtonProps, CircularProgress, Typography } from '@mui/material';

import { TabButtons } from 'shared';
import { Theme, useTheme } from 'themes/themeProvider';
import { Currency } from 'types/general.types';
import { formatCurrency } from 'utils/formatters';

import { TabProp } from './TabsPaidEarnedInfo';

import { costsEarningsInfoSelector, userBaseCurrencySelector } from 'store/slices/user-slice';
import classes from './TabsCostsEarningCard.module.scss';

type Props = {
  size?: ButtonProps['size'];
  isLoading?: boolean;
};

const generateTabs = (costs: number, currency: Currency): TabProp[] => {
  const tabs: TabProp[] = [
    { label: 'Costs', value: formatCurrency(currency, costs) },
    // { label: 'Earnings', value: formatCurrency(currency, earnings) },
    // { label: 'Profit', value: formatCurrency(currency, profit) },
  ];

  return tabs;
};

const Content = ({ amount, theme }: { amount: string; theme: Theme }) => (
  <Box display='flex' flexDirection='column' alignItems={'center'}>
    <FaRegMoneyBill1 size={42} color={theme.widgets.dailyProfit.textColor} />
    <Typography variant='h3' my={1}>
      {amount}
    </Typography>
    <Typography variant='caption'>yesterday</Typography>
  </Box>
);

export const TabsCostsEarningCard = ({ isLoading, size = 'small' }: Props) => {
  const { theme } = useTheme();

  const [selectedTab, setSelectedTab] = React.useState(0);

  const baseCurrency = useSelector(userBaseCurrencySelector) ?? Currency.USD;
  const { costs } = useSelector(costsEarningsInfoSelector) || {
    costs: 0,
    // earnings: 0,
    // profit: 0,
  };

  const tabs = generateTabs(costs, baseCurrency);

  return (
    <Box className={classes.container}>
      {/* Tabs Section */}
      {isLoading ? (
        <div className={classes.loaderContainer}>
          <CircularProgress className={classes.loader} size={24} sx={{ color: theme.widgets.fiatWallet.textColor }} />
        </div>
      ) : (
        <>
          <TabButtons
            size={size}
            tabs={tabs.map(tab => tab.label)}
            activeTab={selectedTab}
            onTabClick={index => setSelectedTab(index)}
          />

          {/* Content Section */}
          <Box display='flex' justifyContent='center' alignItems='center' flexGrow={1} width='100%'>
            <Typography variant='h3' />
            <Content amount={tabs[selectedTab].value} theme={theme} />
          </Box>
        </>
      )}
    </Box>
  );
};
